import { postAnalyticsEvent, postAnalyticsEventSimple } from './common';

const TYPES = {
  BLACKLIST_TEXT: 'BLACKLIST_TEXT',
  SAME_RESPONSE_USED: 'SAME_RESPONSE_USED',
};

export const trackBlacklistTextEvent = async (conversationObjectId, phraseUsed) => {
  const parsePointers = {
    conversationPtr: conversationObjectId,
  };
  const params = {
    phraseUsed,
  };
  await postAnalyticsEvent(TYPES.BLACKLIST_TEXT, parsePointers, params);
};

export const trackSameResponseUsed = async (messageText) => {
  const params = { messageText };
  await postAnalyticsEventSimple(TYPES.SAME_RESPONSE_USED, params);
};
